module.exports = function getResource(label, vars = []) {
    let resources = {
        myBasketLabel: 'Mon panier'
    };

    return resources[label];
};
